export const getDateStr = date => {
  if (date) {
    let d = new Date(date);
    let day = d.getDate(),
      month = d.getMonth() + 1,
      year = d.getFullYear();
    return `${month}/${day}/${year}`;
  } else {
    return null;
  }
}

const toDate = (value) => {
  if (!value) return null;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
};

export const getDateTimeStr = (date, allDay = false) => {
  const d = toDate(date);
  if (!d) return null;
  return allDay
    ? d.toLocaleDateString(undefined, { dateStyle: 'medium' })
    : d.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
}

// Collapses same-day ranges to a single date with two times.
export const getDateRangeStr = (start, end, allDay = false) => {
  const s = toDate(start);
  if (!s) return null;

  const e = toDate(end);
  if (!e || e <= s) return getDateTimeStr(s, allDay);

  const sameDay = s.toDateString() === e.toDateString();

  if (allDay) {
    return sameDay
      ? getDateTimeStr(s, true)
      : `${getDateTimeStr(s, true)} – ${getDateTimeStr(e, true)}`;
  }

  return sameDay
    ? `${getDateTimeStr(s)} – ${e.toLocaleTimeString(undefined, { timeStyle: 'short' })}`
    : `${getDateTimeStr(s)} – ${getDateTimeStr(e)}`;
}